import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';


function SinglePlayerRound({player, results, teams, hostcupId, roundId, scores, roundData}) {

    const [points, setPoints] = useState(0);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [isAdded, setIsAdded] = useState(false)
    const [playerTeams, setPlayerTeams] = useState([])

    const numTeams = roundData.num_teams
    const playersPerTeam = roundData.players_per_team

    const [playerScore, setPlayerScore] = useState([])

    // 1 Get results from draw 1-3
    // 2 Find results where player played in
    // 3 Find points for each draw, sum up
    // 4 Save result for each player, or create array, or both

    useEffect(() => {

        // FIND OUT IF SCORES ALREADY ADDED
        const isAdded = scores.filter(score => {
            return player.player_id === score.player_id
        })
        //console.log(isAdded)
        if (isAdded.length) {
            setIsAdded(true)
        }
        setPlayerScore(isAdded)
        //console.log(player, "PLAYER")
        //console.log(results, "RESULTS")
        //console.log(teams, "TEAMS")

        // FILTER OUT MATCHES WHERE PLAYER IS PARTICIPATING --> TEAMS ARRAY

        // FILTER OUT RESULTS --> RESULTS ARRAY

    }, [scores])

    function calculatePoints() {
        //const teams = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
        function filterTeam(draw) {

            const teamsDraw = teams?.filter(team => {
                console.log(draw, team.draw, "DRaw number")
                return team.draw === draw
            })
            if (teamsDraw) {
                return teamsDraw
            } else {
                return []
            }
            
        }

        // FIND RESULTS RELATED TO DRAW
        function filterResults(draw) {
            const resultsDraw = results.filter(result => {
                return result.draw === draw 
            })
            return resultsDraw
        }

        // FIND PLAYER TEAMS DRAW
        function findTeamPlayer(teams) {
            const teamPlayer = teams?.filter(team => {
                return team.player_id === player.player_id
            })
            return teamPlayer
        }

        // LOOK UP RESULTS
        function findResultPlayer(results, playerTeam) {
            const resultsPlayer = results.filter(result => {
                
                return result.home_team === playerTeam || result.away_team === playerTeam
            })
            console.log(resultsPlayer, "RESULTS PLAYER")
            // FIND IF RESULT TEAM NAME === PLAYER TEAM NAME FOR DRAW
            const playerPoints = resultsPlayer.map(result => {
                console.log(result.home_team, "===", playerTeam)
                let points = 0
                if (result.home_team === playerTeam) {
                    console.log(result.home_points, "HOME POINTS AWARDED")
                    points = result.home_points
                } else {
                    console.log(result.away_points, "AWAY POINTS AWARDED")
                    points = result.away_points
                }
                return points
            })
            let totalPoints = playerPoints[0] + playerPoints[1]

            if (!isNaN(totalPoints)) {
                return totalPoints
            } else {
                return 0
            }
        }

        const teamsRound1 = filterTeam("1");
        const teamsRound2 = filterTeam("2");
        const teamsRound3 = filterTeam("3");

        if (teamsRound1 && teamsRound1 && teamsRound3) {

            console.log(teamsRound1)
            const playerTeam1 = findTeamPlayer(teamsRound1[0]?.teams);
            const playerTeam2 = findTeamPlayer(teamsRound2[0]?.teams);
            const playerTeam3 = findTeamPlayer(teamsRound3[0]?.teams);

            console.log(playerTeam1, "PLAYER TEAM 1")
            // FIND TEAM NAME

            if (playerTeam1 && playerTeam2 && playerTeam3) {
                // USE EXISTING PLAYER TEAM TEAM NAME INSTEAD OF INDEX
                //console.log(playerTeam1[0])
                const teamName1 = playerTeam1[0]?.team_name || "A"
                const teamName2 = playerTeam2[0]?.team_name || "A"
                const teamName3 = playerTeam3[0]?.team_name || "A"
 




                let teamName1Filtered, teamName2Filtered, teamName3Filtered
                if (teamName1) {
                    teamName1Filtered = teamName1
                } else {
                    teamName1Filtered = "X"
                }
                if (teamName2) {
                    teamName2Filtered = teamName2
                } else {
                    teamName2Filtered = "X"
                }
                if (teamName3) {
                    teamName3Filtered = teamName3
                } else {
                    teamName3Filtered = "X"
                }
                const playerTeamNames = teamName1Filtered.concat(teamName2Filtered).concat(teamName3Filtered)
                setPlayerTeams(playerTeamNames)

                // COMPARE TEAM NAME TO RESULTS
                const results1 = filterResults("1")
                const results2 = filterResults("2")
                const results3 = filterResults("3")

                const points1 = findResultPlayer(results1, teamName1)
                const points2 = findResultPlayer(results2, teamName2)
                const points3 = findResultPlayer(results3, teamName3)

                console.log(points1, points2, points3, "POINTS D1,2,3")


                const totalPoints = points1 + points2 + points3
                console.log(totalPoints, "SUM TOTAL POINTS")
                setPoints(totalPoints)

                try {
                    const pointsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("player_scores");
                    
                    const data = {
                        player_name: player.player_name,
                        player_id: player.player_id,
                        points: totalPoints,
                        player_teams: playerTeamNames
                    }
                    
                    pointsRef.add(data);

                    setMessage("Lagret");

                } catch (error) {
                    setError("Kunne ikke lagre")
                }

                return totalPoints

            } else {
                return 0
            }

        } else {
            return 0
        }

        
    }

    function removePoints() {
        
        if (playerScore && playerScore[0]) {
            try {
                console.log("REMOVE")
                console.log(playerScore[0])
                const pointsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("player_scores").doc(playerScore[0].id);
                pointsRef.delete();
                setIsAdded(false)
            } catch (error) {
                console.log(error)
            }

        }
    }

    return (
            <p>
                {player.player_name} {playerScore ? <span className="font-weight-bold">{playerScore[0]?.player_teams}</span> : ""}
                <span className="float-right">
                    {isAdded ? 
                    <i className="fas fa-trash text-danger" onClick={removePoints}></i> 
                    : 
                    <i className="fas fa-plus text-success" onClick={calculatePoints}></i>}
                    
                    
                </span>
            </p>
    )

}
export default SinglePlayerRound